'use strict';

// Localisations
// ============
module.exports = {
  en: {
    title: 'Back to Dashboard',
    nogroup: 'Currently awaiting allocation.',
    joined: 'Joined',
    others: 'The Others',
    me: 'Me'
  },
  es: {
    title: 'Back to Dashboard',
    nogroup: 'Currently awaiting allocation.',
    joined: 'Joined',
    others: 'The Others',
    me: 'Me'
  },
  fr: {

  },
  de: {

  }
};



// WEBPACK FOOTER //
// ./client/app/group/group.localisations.js